export default __webpack_public_path__ + "ec8873ae6d3c6241da1c2b566f491bf8.png";